import React, { Fragment, useContext, useEffect } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { GenerateQuestion } from "../question-generator";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import susenergyimg from "../../img/SustinableEnergy.png";
import * as questionTypes from "../question-types";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Checkbox,
} from "@material-ui/core/";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AdjustIcon from "@material-ui/icons/Adjust";
import withStyles from "@material-ui/core/styles/withStyles";
import DataContext from "../../DataContext";

async function putData(url: string, data = {}): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}
interface IProps {
  data: EnvTempSections;
  envStyles: EnvTempStyles;
  addRemoveCompletion: (section: string, amount: number) => void;
  tabName: string;
  refreshData: () => void;
  handleOpen: (guideHtml: string) => void;
}
const IconLeftAccordionSummary = withStyles({
  expandIcon: {
    transform: "rotate(180deg)",
    order: -1,
  },
})(AccordionSummary);
export const GenericEnvTempAccordion: React.FC<IProps> = (props: IProps) => {
  const styles = {
    summ_1st: {
      background: props.envStyles.themeBackground,
      // outline: "#c1d300 2px solid",
      color: props.envStyles.color,
      marginTop: "5px",
    },
    summ_2nd: {
      background: props.envStyles.themeItemBackground,
      color: props.envStyles.color,
      marginTop: "0px",
      borderRadius: "10px",
      //   width: "100%",
    },
    check_box: {
      color: props.envStyles.themeItemBackground,
      marginTop: "0px",
    },
    check_radio: {
      color: props.envStyles.color,
      marginTop: "15px",
    },
    button: {
      background: props.envStyles.themeItemBackground,
      color: props.envStyles.color,
      marginTop: "10px",
      width: "150px",
    },
    detail_1st: {
      padding: "10px 0px",
      // border: "black solid 2px",
    },
    accord_2nd: {
      boxShadow: "none",
      width: "100%",
    },
  };
  const [expanded, setExpanded] = React.useState<string | false>(false);

  // const perSection = 100 / Object.keys(props.data).length;
  return (
    <Fragment>
      {Object.keys(props.data.subThemes).map((section: string) => {
        return (
          <Fragment key={section}>
            <GenericAccordionSubTheme
              expanded={expanded}
              setExpanded={setExpanded}
              {...props}
              section={section}
              styles={styles}
            />
          </Fragment>
        );
      })}
    </Fragment>
  );
};

interface GenericAccordionDetailsProps {
  styles: {
    summ_1st: {
      background: string;
      color: string;
      marginTop: string;
    };
    summ_2nd: {
      background: string;
      color: string;
      marginTop: string;
    };
    check_box: {
      // background: string;
      color: string;
      marginTop: string;
    };
    check_radio: {
      // background: string;
      color: string;
      marginTop: string;
    };
    button: {
      background: string;
      color: string;
      marginTop: string;
      width: string;
    };
    detail_1st: {
      padding: string;
    };
    accord_2nd: {
      boxShadow: string;
    };
  };
  themeItem: ThemeItem;
  amount: number;
  addRemoveCompletion: (section: string, amount: number) => void;
  tabName: string;
  setCompleted(themeItem: number, completed: boolean): void;
  refreshData: () => void;
  handleOpen: (guideHtml: string) => void;
}
const GenericAccordionDetails: React.FC<GenericAccordionDetailsProps> = (
  props: GenericAccordionDetailsProps
) => {
  const context = useContext(DataContext);

  // useEffect(() => {
  //   if (props.themeItem.completed) {
  //     props.setCompleted(props.themeItem.id.toString(), true);
  //   }
  // }, []);
  const [ticked, setTicked] = React.useState<boolean>(
    props.themeItem.completed ? props.themeItem.completed : false
  );
  const [render, reRender] = React.useState<boolean>(false);

  const [answers, setAnswers] = React.useState<{
    [questionId: string]: { choice: string; answer: string };
  }>({});
  function putAnswerCallback(id: number, choice: string, answer: string) {
    const existingAnswers = answers;
    existingAnswers[id.toString()] = { choice: choice, answer: answer };
    setAnswers(existingAnswers);

    const contextAnswers = context.answers;
    var foundAnswer = contextAnswers.find(
      (x) => x.questionId === id && x.choice === choice
    );
    if (foundAnswer) {
      contextAnswers.map((x) => {
        if (x.questionId === id && x.choice === choice) {
          var newAnswer = x;
          newAnswer.answer = answer;
          return newAnswer;
        } else {
          return x;
        }
      });
    } else {
      contextAnswers.push({
        id: -1,
        questionId: id,
        user_id: context.userId,
        city_council_id: 0,
        choice: choice,
        answer: answer,
        year: 2021,
      });
    }

    context.setAnswers(contextAnswers);
    reRender(!render);
  }
  function saveAnswers() {
    if (Object.keys(answers).length > 0) {
      Object.keys(answers).forEach((questionId: string) => {
        putData(
          "https://greencityapi-new.absolarlab.com/api/Answer/" + questionId,
          {
            choice: answers[questionId].choice,
            answer: answers[questionId].answer,
            user_id: context.userId,
            city_council_id: 0,
            year: 2021,
          }
        ).then(() => {
          props.refreshData();
        });
      });
    }
  }
  return (
    <AccordionDetails style={props.styles.detail_1st}>
      <Accordion style={props.styles.accord_2nd}>
        <IconLeftAccordionSummary
          expandIcon={
            <Fragment>
              {ticked ? (
                <RadioButtonCheckedIcon style={props.styles.check_radio} />
              ) : (
                <RadioButtonUncheckedIcon style={props.styles.check_radio} />
              )}
            </Fragment>
          }
          style={props.styles.summ_2nd}
        >
          {/* <img src={susenergyimg} className="heading_img_2" /> */}

          <div style={{ textAlign: "center", width: "100%" }}>
            <div className="heading_2">
              <span className="heading_2_main">{props.themeItem.title}</span>
              <br />
            </div>
          </div>
        </IconLeftAccordionSummary>
        <AccordionDetails
          style={{
            borderStyle: "solid",
            borderColor: "lightGrey",
            borderWidth: 5,
            borderRadius: "15px",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <button
                style={{
                  background: "none!important",
                  border: "none",
                  padding: "0!important",

                  color: "#069",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  props.handleOpen(props.themeItem.guide);
                }}
              >
                Guide
              </button>
            </Grid>
            {props.themeItem.questions.map((questionData: Question) => {
              var show = true;
              if (questionData.modifiers.length > 0) {
                show = questionData.modifiers.every((modifier) => {
                  if (modifier.effect === "show") {
                    var matchingRequirementAnswer = context.answers.find(
                      (x) => x.questionId === modifier.questionModifierId
                    );
                    if (matchingRequirementAnswer) {
                      if (
                        matchingRequirementAnswer.answer ===
                        modifier.requirement
                      ) {
                        return true;
                      } else {
                        return false;
                      }
                    } else {
                      return false;
                    }
                  }
                });
              }

              if (show) {
                return (
                  <GenerateQuestion
                    key={questionData.id}
                    question={questionData.question}
                    help={questionData.help}
                    type={questionData.type}
                    choices={questionData.choices}
                    id={questionData.id}
                    putAnswerCallback={putAnswerCallback}
                    carbonQuestion={false}
                    orgInfoQuestion={false}
                    index={0}
                  />
                );
              } else {
                return null;
              }
            })}
            <Button
              style={props.styles.button}
              onClick={() => {
                saveAnswers();
              }}
            >
              {" "}
              Save{" "}
            </Button>
            <div className="check_box">
              <Checkbox
                checked={ticked}
                style={props.styles.check_box}
                onChange={(e) => {
                  setTicked(e.target.checked);
                  props.setCompleted(props.themeItem.id, e.target.checked);
                  if (e.target.checked) {
                    props.addRemoveCompletion(props.tabName, 1);
                  } else {
                    props.addRemoveCompletion(props.tabName, -1);
                  }
                  putData(
                    "https://greencityapi-new.absolarlab.com/api/ThemeItem/" +
                      props.themeItem.id +
                      "/complete",
                    { user_id: context.userId, complete: e.target.checked }
                  ).then(() => {
                    props.refreshData();
                  });
                }}
              />
              Mark as complete
            </div>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </AccordionDetails>
  );
};

interface SubThemeProps {
  section: string;
  styles: {
    summ_1st: {
      background: string;
      // outline: "#c1d300 2px solid",
      color: string;
      marginTop: string;
    };
    summ_2nd: {
      background: string;
      color: string;
      marginTop: string;
      borderRadius: string;
    };
    check_box: { color: string; marginTop: string };
    check_radio: { color: string; marginTop: string };
    button: {
      background: string;
      color: string;
      marginTop: string;
      width: string;
    };
    detail_1st: { padding: string };
    accord_2nd: { boxShadow: string; width: string };
  };
  data: EnvTempSections;
  envStyles: EnvTempStyles;
  addRemoveCompletion: (section: string, amount: number) => void;
  tabName: string;
  refreshData: () => void;
  expanded: string | false;
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>;
  handleOpen: (guideHtml: string) => void;
}
const GenericAccordionSubTheme: React.FC<SubThemeProps> = (
  props: SubThemeProps
) => {
  const [completedThemeItems, setCompletedThemeItems] = React.useState<
    number[]
  >([]);
  function setCompleted(themeItem: number, completed: boolean) {
    if (completed) {
      if (!completedThemeItems.includes(themeItem)) {
        completedThemeItems.push(themeItem);
      }
    } else {
      const newCompleted = completedThemeItems.filter(
        (includedThemeItem) => includedThemeItem !== themeItem
      );
      setCompletedThemeItems(newCompleted);
    }
  }
  useEffect(() => {
    const newCompleted: number[] = [];
    props.data.subThemes[props.section].themeItems.map(
      (themeItem: ThemeItem) => {
        if (themeItem.completed) {
          newCompleted.push(themeItem.id);
        }
      }
    );
    setCompletedThemeItems(newCompleted);
  }, []);
  return (
    <Accordion
      expanded={props.expanded === props.section}
      onChange={() => {
        if (props.expanded === props.section) {
          props.setExpanded(false);
        } else {
          props.setExpanded(props.section);
        }
      }}
      style={{ boxShadow: "none" }}
    >
      <AccordionSummary
        style={props.styles.summ_1st}
        expandIcon={<ExpandMoreIcon style={props.styles.check_radio} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        {completedThemeItems.length ===
        props.data.subThemes[props.section].themeItems.length ? (
          <RadioButtonCheckedIcon style={props.styles.check_radio} />
        ) : (
          <RadioButtonUncheckedIcon style={props.styles.check_radio} />
        )}
        <img
          src={props.data.subThemes[props.section].img}
          // style={{ width: "35px", height: "35px",  }}
          className="template_summ_2_image"
        />
        <p className="heading_1">{props.section}</p>
      </AccordionSummary>
      {props.data.subThemes[props.section].themeItems.map(
        (themeItem: ThemeItem) => {
          return (
            <Fragment key={themeItem.id}>
              <GenericAccordionDetails
                styles={props.styles}
                themeItem={themeItem}
                amount={1}
                addRemoveCompletion={props.addRemoveCompletion}
                tabName={props.tabName}
                setCompleted={setCompleted}
                refreshData={props.refreshData}
                handleOpen={props.handleOpen}
              />
            </Fragment>
          );
        }
      )}
    </Accordion>
  );
};
